/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';

class RecurlySubscriptionPausedModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pauseError: ''
        };

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps && prevProps.app.loading.SUB_PAUSE_SUBSCRIPTION === true && this.props.app.loading.SUB_PAUSE_SUBSCRIPTION === false) {
			// modal will handle any error display
			let pauseErrors = this.props.getApiErrors(['SUB_PAUSE_SUBSCRIPTION']);
			if (pauseErrors.length) {
                let error = pauseErrors[0],
                    errorText = '',
                    keys = [];

                if (error.errors.validation !== undefined) {
                    keys = Object.keys(error.errors.validation);
                    errorText = error.errors.validation[keys[0]];
                } else if (error.errors.recurly !== undefined) {
                    keys = Object.keys(error.errors.recurly);
                    errorText = error.errors.recurly[keys[0]];
                }
                this.setState({
                    pauseError: errorText
                });
                this.props.deleteApiError(['SUB_PAUSE_SUBSCRIPTION']);
			}
		}
    }

    render() {
        let modalContent = null,
            imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl;

        modalContent = (
            <div className="trial-end-warning">
                <div className="big-icon">
                    <img src={`${imageUrl}/upgrade-modal/trial-end-hourglass.svg`} width="175" height="auto"/>
                </div>
                <div className="warning-content">
                    <h3 style={{"fontWeight": 500}}>Your subscription is paused.</h3>
                    {(this.state.pauseError !== '') ? (
                        <div className="trial-error">
                            {this.state.pauseError}
                        </div>
                    ) : null}
                    <p>
                        Service and billing will resume {moment(this.props.user.plan.pauseEnd).format("MMM D, YYYY")}.<br/>
                        To restart posting immediately, press the button below.
                    </p>
                </div>
                <div className="warning-dismiss" onClick={(e) => {
                    this.props.pauseSubscription({
                        duration: 0
                    });
                }} role="button" aria-label="subscribe">
                    Resume Posting
                </div>
            </div>
        )

        return (
            <Modal
                content={modalContent}
                boxClass={"trial-end-box"}
                mainClass={"trial-end-content"} />
        );
    }
}

RecurlySubscriptionPausedModal.displayName = "RecurlySubscriptionPausedModal";

export default RecurlySubscriptionPausedModal;
